<template>
    <scroll-pull-down onScrollTop="'0.88rem'" :onAreMore="false" :onRefreshDelay="options.refreshDelay" onScrollBackgroundColor="#FFF">
        <div class="page-head box-shadow" slot="header">
            选择店铺
        </div>
        <div class="app-screen" slot="container">
            <section class="shop-container" v-for="(item, index) in listing" :key="index">
                <div class="shop-name" @click="selectShop(item)">{{item.shop_name}}</div>
            </section>
        </div>
    </scroll-pull-down>
</template>
<script>
    import ScrollPullDown from '@/public/ScrollPullDown'
    import Core from '@/until/core'
    export default {
        name: 'SelectShop',
        data () {
            return {
                options: {
                    refreshDelay: 0,
                    accessToken: null
                },
                database: {
                    search: {
                        search_value: ''
                    },
                    paging: {
                        totalrecord: 0,
                        totalpage: 0,
                        currentpage: 0,
                        pagesize: 20,
                        pageint: 0
                    },
                    list: []
                }
            }
        },
        components: {
            ScrollPullDown
        },
        watch: {},
        computed: {
            listing () {
                let list = this.database.list || []
                for (let item of list) {
                    item.macList = JSON.parse(item.mac || '[]')
                }
                return list
            }
        },
        filters: {},
        methods: {
            onGetDatabase () {
                const that = this
                const param = {}
                that.$store.commit('onChangeAppLoaderShow', true)
                Core('Api/User/Detailedstore', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data || body.data.error_code) {
                        return that.$store.commit('onChangeAppMessage', body.data.error_msg)
                    }
                    that.database.list = body.data.data
                })
            },
            selectShop (item) {
                const that = this
                layer.open({
                    title: '提示',
                    content: '确定要选择' + item.shop_name + '吗？',
                    btn: ['确定', '取消'],
                    yes (index, layero) {
                        layer.close(index)
                        localStorage.setItem('mac', item.macList[0] || '')
                        Core.goNext('Home', that.$route.params)
                    },
                    btn2 (index, layero) {
                        layer.close(index)
                    }
                })
            }
        },
        mounted () {
            this.onGetDatabase()
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
    .app-screen{ padding-top: 1rem; }
    .shop-container{ background-color: #fff; }
    .shop-name{ padding: 10px; border-bottom: 1px solid #f8f8f8; }
</style>



// WEBPACK FOOTER //
// src/components/SelectShop.vue